<div class="trial-lockout-overlay" *ngIf="trialLockedOut">
    <div class="trial-lockout-card">
        <i class="pi pi-lock trial-lockout-icon"></i>
        <h2>Billing card required</h2>
        <p>
            <ng-container *ngIf="planExpiredDateText">Your free trial ended on {{ planExpiredDateText }}. </ng-container>Add a card on file for your {{ _globals.whiteLabel.wlName }} subscription billing to continue — everything is on hold until a payment method is on file.
        </p>
        <app-stripe-add-card-button label="Add card" (cardSaved)="onLockoutCardSaved($event)"></app-stripe-add-card-button>
    </div>
</div>
<div
    class="layout-wrapper"
    [ngClass]="{
        'online-store-setup-route': isOnlineStoreSetupPage,
        'layout-overlay': isOverlay(),
        'layout-static': isStatic(),
        'layout-theme-light': !config.dark,
        'layout-theme-dark': config.dark,
        'layout-overlay-sidebar-active': overlayMenuActive,
        'layout-static-sidebar-inactive': staticMenuInactive,
        'layout-mobile-sidebar-active': menuActiveMobile,
        'p-ripple-disabled': !config.ripple,
        'p-input-filled': config.inputStyle === 'filled'
    }"
>
    <div class="status-strip" *ngIf="showStoreContentBanner" [class.status-strip-success]="isStoreContentBannerCompleted">
        <span class="status-strip-text">{{ storeContentBannerMessage }}</span>
        <button
            type="button"
            class="status-strip-action"
            *ngIf="showStoreContentDashboardLink"
            (click)="goToDashboardFromStoreContentBanner()"
        >
            Click here
        </button>
    </div>
    <app-topbar></app-topbar>
    <div class="layout-sidebar" [ngClass]="{'pointer-events-none': _globals.currentTour <= _globals.totalTour && isDesktop() &&  _globals.totalTour>99999}">
        <!-- <app-menu></app-menu> -->
        <!-- <app-menu-left></app-menu-left> -->
         
             <app-sidebar></app-sidebar>
    </div>
    <div class="main-tour" *ngIf="_globals.currentTour <= _globals.totalTour && _globals.currentTour>99 && isDesktop()">
<app-welcome-tour></app-welcome-tour>
    </div>

    <!-- <div class="layout-top-container" *ngIf="IsUserOnTrial && !isOnlineStore">
        <div>
&nbsp;
    </div>
 <div class="dashboard-center-free-trial" >You Have {{dayLeftInRenewal}} Days Left in Your Free Trial. <span class="plan-btn-upgrade cursor-pointer" (click)="navigateToSubscription()" *ngIf="!IsOnSubscriptionPage && showUpgradeBtn">Upgrade Plan</span> </div>
 <div class="dashboard-center-free-trial" >You Have {{dayLeftInRenewal}} Days Left in Your Free Trial. <span class="plan-btn-upgrade"></span> </div>
<div>&nbsp;</div>
</div> -->
    <div class="layout-main-container" [ngClass]="{
        'has-plan-banner': showPlanBanner && !isOnBillingPage,
        'no-banner': !showPlanBanner
    }" >

        <div class="plan-expired-banner p-3 mb-1" *ngIf="showPlanBanner && !isOnBillingPage">
            <div class="flex flex-column md:flex-row align-items-start md:align-items-center justify-content-between gap-3">
                <div class="flex align-items-start gap-3">
                    <i class="pi pi-exclamation-triangle banner-icon"></i>
                    <div class="flex flex-column gap-1">
                        <span class="alert-title">
                            {{ isPlanExpired ? 'Your subscription has expired.' : 'Your subscription is about to expire.' }}
                        </span>
                        <span class="alert-subtitle" *ngIf="isPlanExpired">
                            Please renew your plan to restore access
                            <ng-container *ngIf="planExpiredDateText"> (last active {{ planExpiredDateText }})</ng-container>.
                        </span>
                        <span class="alert-subtitle" *ngIf="!isPlanExpired && isPlanExpiringSoon">
                            You have {{ planExpiresInDays }} day{{ planExpiresInDays === 1 ? '' : 's' }} remaining.
                        </span>
                    </div>
                </div>
                <div class="flex gap-2 flex-wrap">
                    <button pButton type="button" label="Manage billing" class="p-button-rounded p-button-danger"
                        (click)="goToBillingAndPlans(true)"></button>
                    <button pButton type="button" label="Back to previous page" class="p-button-rounded p-button-secondary"
                        *ngIf="showPlanBannerBackButton" (click)="goBackFromBilling()"></button>
                </div>
            </div>
        </div>

        <div class="pb-2 mb-1" *ngIf="_abd.isUserOnDashboard && _abd.isSetupGuide && _abd.isAdmin">
        <h6 class="font-semibold text-xl my-1">
            Hello! {{_globals.userInfo.firstName}} {{_globals.userInfo.lastName}}
        </h6>
        <p >
            Achieve a smooth store launch by following our step-by-step guide below.
        </p>
      </div>
        <!-- <div class="card py-1 border-radius-none" *ngIf="IsUserOnTrial && !isOnlineStore">
            <div class="flex flex-row flex-wrap  card-container  ">
                <div class="flex align-items-center justify-content-center m-2 flex-grow-1 " *ngIf="IsUserOnTrial">
                    <span *ngIf="IsUserOnTrial ">
                        <div class="flex font-bold text-lg align-items-center">
                            <span>You are currently on 30 Day free trial which is ending in {{dayLeftInRenewal}} days.</span>
                            <p-button *ngIf="!IsOnSubscriptionPage && showUpgradeBtn" label="View Details"
                                (click)="navigateToSubscription()" styleClass="mx-3">
                            </p-button>
                        </div>
                    </span>
                </div>
            </div>
        </div> -->
        <div class="layout-main mt-4">
            <router-outlet></router-outlet>
        </div>
        <!-- <app-footer></app-footer> -->
    </div>
    <app-config></app-config>
    <!-- <div *ngIf="menuActiveMobile" class="layout-mask p-component-overlay" (click)="toggleMenuDummy()"></div> -->
</div>

<p-dialog [dismissableMask]="true" [(visible)]="_abd.isDownloadPosApp" [style]="{width: '50vw'}">
    <div class="flex justify-content-center font-bold py-2 pb-4 " style=" color:var(--brandColor);font-size: large;">
     Please scan the QR Code to Download the Point-of-Sale App
    </div>
    <div class="flex justify-content-between  ">
      <div class="flex flex-column align-items-center justify-content-between">
     <img width="200px" height="200px" src="assets/images/app-store.png" alt="QR Code">
     <span class="flex align-items-center">
         <img src="./../assets/images/app-store-icon.svg" alt="" width="15px" height="15px">&nbsp; App Store
     </span>
    </div>
    <div class="flex flex-column align-items-center justify-content-between">   <img width="200px" height="200px" src="assets/images/play-store.png" alt="QR Code">
 <span class="flex align-items-center">
    <img src="./../assets/images/play-store-icon.svg" alt="" width="15px" height="15px">&nbsp; Play Store
 </span>
 </div>
    <div class="flex flex-column align-items-center justify-content-between">   <img width="200px" height="200px" src="assets/images/pax-store.png" alt="QR Code">
 <span class="flex align-items-center">
    <img src="./../assets/images/pax-store-icon.png" alt="" width="15px" height="15px"> &nbsp; Pax Store
 </span>
 </div>
    </div>
</p-dialog>
